import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// A6-ish printable parcel card: brand, order number, QR, date
export default function AdminPrintCard() {
  const { orderNo } = useParams();
  const { user, ready } = useAuth();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [qr, setQr] = useState(null);

  const isStaff = user && ["admin", "super_admin", "manager"].includes(user.role);
  useEffect(() => { if (ready && !isStaff) navigate("/login?redirect=/admin"); }, [ready, isStaff]);

  useEffect(() => {
    if (!isStaff) return;
    api.get(`/admin/orders/${orderNo}/detail`).then((r) => setOrder(r.data)).catch(() => {});
    api.get(`/admin/orders/${orderNo}/qr`).then((r) => setQr(r.data)).catch(() => {});
  }, [isStaff, orderNo]);

  if (!order || !qr) return <div className="flex min-h-screen items-center justify-center text-ink/50">جارِ تجهيز بطاقة الطباعة...</div>;

  return (
    <div className="flex min-h-screen flex-col items-center bg-sand/30 px-4 py-10">
      <div className="no-print mb-6 flex gap-3">
        <button data-testid="print-card-btn" onClick={() => window.print()}
          className="flex items-center gap-2 rounded-full bg-olive px-7 py-3 font-semibold text-ivory">
          <Printer className="h-5 w-5" /> طباعة البطاقة
        </button>
        <button onClick={() => window.close()} className="flex items-center gap-2 rounded-full border border-olive/25 px-6 py-3 text-sm font-semibold text-olive-dark">
          <ArrowLeft className="h-4 w-4" /> إغلاق
        </button>
      </div>

      <div data-testid="parcel-card" dir="rtl"
        className="w-[105mm] rounded-lg border-2 border-olive-deep bg-white p-5 text-center shadow-sm print:border-black">
        <div className="flex items-center justify-center gap-2.5 border-b-2 border-olive-deep/15 pb-3">
          <img src="/logo.png" alt="سهول جنين" className="h-12 w-12 rounded-lg object-cover" />
          <div className="text-right">
            <div className="font-display text-xl font-bold text-olive-deep">سهول جنين</div>
            <div className="text-[10px] text-ink/50">جودة من أرضنا 🇵🇸</div>
          </div>
        </div>
        <div className="mt-3 text-xs text-ink/55">رقم الطلب</div>
        <div className="font-display text-2xl font-bold tracking-wide text-ink" dir="ltr">#{order.order_no}</div>
        <img src={qr.image} alt="QR" className="mx-auto mt-3 h-44 w-44" />
        <div className="mt-3 text-xs text-ink/55">
          تاريخ الطلب: {new Date(order.created_at).toLocaleDateString("ar")}
        </div>
        <div className="mt-1 text-xs text-ink/55">العميل: {order.name}</div>
        <div className="mt-3 border-t border-dashed border-olive-deep/20 pt-2 text-[10px] text-ink/45">
          امسح الرمز بعد تسجيل الدخول لعرض الفاتورة الإلكترونية
        </div>
      </div>
    </div>
  );
}
